export enum EcmDocumentCategory {
    CMR,
    Docs,
    Fin = 4
}